<p-wrapper id="page-fail" titleWrapper="Erreur !" [withHomeButton]="true">
  <div body>
    <div class="text-center">
      <img src="assets/images/fail.png" class="image-error mb-2" alt="échec" />
      <p>{{ message }}</p>
    </div>
  </div>
</p-wrapper>
